export default __webpack_public_path__ + "static/media/19.1edaea0f.jpg";